export const brand = {
  name: 'Pixel Utility',
  mainDomain: 'https://pixelutility.com',
  subdomain: 'clothing-shoe-size-converter.pixelutility.com',
  logoPath: `${process.env.PUBLIC_URL}/logo.png`,
};
